import { NavItem } from '@abovo/shared-models';
import { CardComponent, CardContentComponent } from '@abovo/shared-ui-components';
import { PageWrapperDeprecated } from '@abovo/webvis-ui';
import { NgTemplateOutlet } from '@angular/common';
import { ChangeDetectorRef, Component, ElementRef, inject, TemplateRef, ViewChild, ViewEncapsulation } from '@angular/core';
import { MatButton } from '@angular/material/button';
import { MatDrawer } from '@angular/material/sidenav';
import { UntilDestroy } from '@ngneat/until-destroy';
import { TranslatePipe } from '@ngx-translate/core';
import { InfiniteScrollDirective } from 'ngx-infinite-scroll';
import { BehaviorSubject } from 'rxjs';

/**
 * @deprecated Do not use this, can be deleted after refactoring TasksPageComponent
 */
@UntilDestroy()
@Component({
   selector: 'abovo-webvis-page-wrap-v2',
   templateUrl: './webvis-page-wrap-v2.component.html',
   styleUrls: ['./webvis-page-wrap-v2.component.scss'],
   encapsulation: ViewEncapsulation.Emulated,
   imports: [NgTemplateOutlet, InfiniteScrollDirective, MatButton, TranslatePipe, CardComponent, CardContentComponent],
})
export class WebvisPageWrapV2Component implements PageWrapperDeprecated {
   cd = inject(ChangeDetectorRef);
   content?: TemplateRef<any>;
   sideContent?: TemplateRef<any>;
   sideContentTop?: TemplateRef<any>;
   drawer?: MatDrawer;
   drawerContent?: TemplateRef<any>;
   navItems$ = new BehaviorSubject<NavItem[]>([]);
   showNav = false;
   subTitle?: TemplateRef<any>;
   title?: string;
   scrollHandler?: () => void;
   showScrollFallback?: { loading: boolean; hasNextPage: boolean; template?: TemplateRef<any> };

   @ViewChild('scrollContainer')
   public scrollContainer?: ElementRef<HTMLDivElement>;

   onScroll = () => {
      this.scrollHandler?.();
   };
}
